var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFont(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30482",
    "data-name": "Group 30482",
    transform: "translate(10202 -17476)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14179",
    "data-name": "Rectangle 14179",
    width: 32,
    height: 32,
    transform: "translate(-10202 17476)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30482-2",
    "data-name": "Group 30482"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14179-2",
    "data-name": "Rectangle 14179",
    width: 32,
    height: 32,
    transform: "translate(-10202 17476)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "type_1_",
    "data-name": "type (1)",
    transform: "translate(-10200 17478)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50123",
    "data-name": "Path 50123",
    d: "M4,7V4H24V7",
    fill: "none",
    stroke: "#adadad",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1021",
    "data-name": "Line 1021",
    x2: 6,
    transform: "translate(11 24)",
    fill: "none",
    stroke: "#adadad",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1022",
    "data-name": "Line 1022",
    y2: 20,
    transform: "translate(14 4)",
    fill: "none",
    stroke: "#adadad",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFont);
export default __webpack_public_path__ + "static/media/font.33fe999f.svg";
export { ForwardRef as ReactComponent };